module.exports = __webpack_public_path__ + "static/elephantcomfblanket-374b8afd92937ba233bd8d2f29635933.jpeg";